import { createSlice } from '@reduxjs/toolkit';

const assessmentsSlice = createSlice({
    name: 'assessments',
    initialState: {
        allAssessments: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        allReAssessmentRequests: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        allQuestions: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        randomTraitQuestions: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        randomProjectiveQuestions: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        singleAssessment: { data: null, loading: false, error: null },
        createAssessment: { data: null, loading: false, error: null },
        updateAssessment: { data: null, loading: false, error: null },
        updateReAssessmentRequest: { data: null, loading: false, error: null },
        createQuestion: { data: null, loading: false, error: null },
        updateQuestion: { data: null, loading: false, error: null },
        importAssessments: {
                    loading: false,
                    error: null,
                },
    },
    reducers: {
        // Start actions
        fetchAssessmentsStart: (state, action) => {
            state.allAssessments.loading = true;
            state.allAssessments.error = null;
            if (action.payload.page === 1) {
                state.allAssessments.data = [];
            }
        },
        fetchReAssessmentRequestsStart: (state, action) => {
            state.allReAssessmentRequests.loading = true;
            state.allReAssessmentRequests.error = null;
            if (action.payload.page === 1) {
                state.allReAssessmentRequests.data = [];
            }
        },
        fetchQuestionsStart: (state, action) => {
            state.allQuestions.loading = true;
            state.allQuestions.error = null;
            if (action.payload.page === 1) {
                state.allQuestions.data = [];
            }
        },
        fetchSingleAssessmentStart: (state) => {
            state.singleAssessment.loading = true;
            state.singleAssessment.error = null;
        },
        fetchRandomTraitQuestionsStart: (state) => {
            state.randomTraitQuestions.loading = true;
            state.randomTraitQuestions.error = null;
        },
        fetchRandomProjectiveQuestionsStart: (state) => {
            state.randomProjectiveQuestions.loading = true;
            state.randomProjectiveQuestions.error = null;
        },
        createAssessmentStart: (state) => {
            state.createAssessment.loading = true;
            state.createAssessment.error = null;
        },
        updateAssessmentStart: (state) => {
            state.updateAssessment.loading = true;
            state.updateAssessment.error = null;
        },
        updateReAssessmentRequestStart: (state) => {
            state.updateReAssessmentRequest.loading = true;
            state.updateReAssessmentRequest.error = null;
        },

        createQuestionStart: (state) => {
            state.createQuestion.loading = true;
            state.createQuestion.error = null;
        },
        updateQuestionStart: (state) => {
            state.updateQuestion.loading = true;
            state.updateQuestion.error = null;
        },
        importAssessmentsStart: (state) => {
            state.importAssessments.loading = true;
            state.importAssessments.error = null;
        },

        // Success actions
        fetchAssessmentsSuccess: (state, action) => {
            state.allAssessments = { ...action.payload, loading: false };
        },
        fetchReAssessmentRequestsSuccess: (state, action) => {
            state.allReAssessmentRequests = { ...action.payload, loading: false };
        },
        fetchQuestionsSuccess: (state, action) => {
            state.allQuestions = { ...action.payload, loading: false };
        },
        fetchSingleAssessmentSuccess: (state, action) => {
            state.singleAssessment = { ...action.payload, loading: false, error: null };
        },
        fetchRandomTraitQuestionsSuccess: (state, action) => {
            state.randomTraitQuestions.loading = false;
            state.randomTraitQuestions.data = action.payload;
        },
        fetchRandomProjectiveQuestionsSuccess: (state, action) => {
            state.randomProjectiveQuestions.loading = false;
            state.randomProjectiveQuestions.data = action.payload;
        },
        createAssessmentSuccess: (state, action) => {
            state.createAssessment.loading = false;
            state.createAssessment.data = action.payload;
        },
        updateAssessmentSuccess: (state, action) => {
            state.updateAssessment.loading = false;
            state.updateAssessment.data = action.payload;
        },
        updateReAssessmentRequestSuccess: (state, action) => {
            state.updateReAssessmentRequest.loading = false;
            state.updateReAssessmentRequest.error = action.payload;
        },
        createQuestionSuccess: (state, action) => {
            state.createQuestion.loading = false;
            state.createQuestion.data = action.payload;
        },
        updateQuestionSuccess: (state, action) => {
            state.updateQuestion.loading = false;
            state.updateQuestion.data = action.payload;
        },
         importAssessmentsSuccess: (state,action) => {
            state.importAssessments.loading = false;
            state.importAssessments.error = null;
        },
        

        // Fail actions
        fetchAssessmentsFail: (state, action) => {
            state.allAssessments.loading = false;
            state.allAssessments.error = action.payload;
        },
        fetchReAssessmentRequestsFail: (state, action) => {
            state.allReAssessmentRequests.loading = false;
            state.allReAssessmentRequests.error = action.payload;
        },
        fetchQuestionsFail: (state, action) => {
            state.allQuestions.loading = false;
            state.allQuestions.error = action.payload;
        },
        fetchSingleAssessmentFail: (state, action) => {
            state.singleAssessment.loading = false;
            state.singleAssessment.error = action.payload;
        },
        fetchRandomTraitQuestionsFail: (state, action) => {
            state.randomTraitQuestions.loading = false;
            state.randomTraitQuestions.error = action.payload;
        },
        fetchRandomProjectiveQuestionsFail: (state, action) => {
            state.randomProjectiveQuestions.loading = false;
            state.randomProjectiveQuestions.error = action.payload;
        },
        createAssessmentFail: (state, action) => {
            state.createAssessment.loading = false;
            state.createAssessment.error = action.payload;
        },
        updateAssessmentFail: (state, action) => {
            state.updateAssessment.loading = false;
            state.updateAssessment.error = action.payload;
        },
        updateReAssessmentRequestFail: (state, action) => {
            state.updateReAssessmentRequest.loading = false;
            state.updateReAssessmentRequest.error = action.payload;
        },
        createQuestionFail: (state, action) => {
            state.createQuestion.loading = false;
            state.createQuestion.error = action.payload;
        },
        updateQuestionFail: (state, action) => {
            state.updateQuestion.loading = false;
            state.updateQuestion.error = action.payload;
        },
        importAssessmentsFail: (state,action) => {
            state.importAssessments.loading = false;
            state.importAssessments.error = action.payload;
        },
    },
});

export const {
    fetchAssessmentsStart,
    fetchAssessmentsSuccess,
    fetchAssessmentsFail,

    fetchQuestionsStart,
    fetchQuestionsSuccess,
    fetchQuestionsFail,

    fetchSingleAssessmentStart,
    fetchSingleAssessmentSuccess,
    fetchSingleAssessmentFail,

    fetchRandomTraitQuestionsStart,
    fetchRandomTraitQuestionsSuccess,
    fetchRandomTraitQuestionsFail,

    fetchRandomProjectiveQuestionsStart,
    fetchRandomProjectiveQuestionsSuccess,
    fetchRandomProjectiveQuestionsFail,

    fetchReAssessmentRequestsStart,
    fetchReAssessmentRequestsSuccess,
    fetchReAssessmentRequestsFail,

    createAssessmentStart,
    createAssessmentSuccess,
    createAssessmentFail,

    updateAssessmentStart,
    updateAssessmentSuccess,
    updateAssessmentFail,

    createQuestionStart,
    createQuestionSuccess,
    createQuestionFail,

    updateQuestionStart,
    updateQuestionSuccess,
    updateQuestionFail,

    importAssessmentsStart,
    importAssessmentsSuccess,
    importAssessmentsFail,

    updateReAssessmentRequestStart,
    updateReAssessmentRequestSuccess,
    updateReAssessmentRequestFail
} = assessmentsSlice.actions;

export default assessmentsSlice.reducer;